import React from 'react';
import {PieChart, Pie, Cell, Sector} from 'recharts';
import "./CircularChart.scss";

const CustomLabel = (props) => {
  let RADIAN = Math.PI / 180;
  let {cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value} = props;
  let sin = Math.sin(-RADIAN * midAngle);
  let cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  if (payload.name === 'Remaining') {
    return null;
  }

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none"/>
      <circle cx={ex} cy={ey} r={4} fill={fill} stroke="none"/>
      <text className='iransans-b circular-rechart-text' x={ex + (cos >= 0 ? 5 : -5) * 12} y={ey}
            textAnchor={textAnchor} fill="#333">{`${value}%`}</text>
    </g>
  );
};

const CircularChart = ({firstValue, secondValue, firstTitle, secondTitle, generalTitle, firstColor, secondColor ,data}) => {
  let RemainingValue = 100 - (firstValue + secondValue);

  const COLORS = [firstColor, secondColor, '#F1F1F1'];

  return (
    <div className='circular_chart'>
      <PieChart width={400} height={400}>
        <Pie
          data={data}
          cx='50%'
          cy='50%'
          outerRadius={150}
          innerRadius={110}
          fill="#8884d8"
          dataKey="value"
          labelLine={false}
          startAngle={360}
          endAngle={0}
          label={CustomLabel} // Use CustomLabel for pie chart labels
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
          ))}
        </Pie>
        <circle cx={200} cy={200} r={100} fill="#FFFFFF"/>
      </PieChart>
      <div className='status_container'>
        <div className='status'>
          <div className='status_square' style={{backgroundColor: '#F1F1F1'}}></div>
          <span className='status_text iransans-b'>{generalTitle}</span>
        </div>
        <div className='status'>
          <div className='status_square' style={{backgroundColor: firstColor}}></div>
          <span className='status_text iransans-b'>{firstTitle}</span>
        </div>
        <div className='status'>
          <div className='status_square' style={{backgroundColor: secondColor}}></div>
          <span className='status_text iransans-b'>{secondTitle}</span>
        </div>
      </div>
    </div>
  );
};

export default CircularChart;